exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-resync-container[data-v-b183c636]{display:inline;margin-left:10px;text-align:left}.order-resync-container .bill-range-tips[data-v-b183c636]{color:#909399}.order-resync-container .bill-range-tips.error[data-v-b183c636]{color:#F56C6C}.order-resync-form-dialog .el-form-item[data-v-b183c636]{margin-bottom:12px}.order-resync-form-dialog .bill-tips[data-v-b183c636]{color:#909399}.order-resync-form-dialog .bill-tips.error[data-v-b183c636]{color:#F56C6C}.order-resync-form-dialog .error-num[data-v-b183c636]{color:#F56C6C}\n", ""]);

// exports
